import React from 'react';
import RcRange from 'rc-slider/lib/Range';
export default class Range extends React.Component {
    render() {
        return (<div className={`${this.props.prefixCls}-wrapper`}><RcRange {...this.props}/></div>);
    }
}
Range.defaultProps = {
    prefixCls: 'am-slider',
};



// WEBPACK FOOTER //
// ./components/range/index.tsx